import type { FaireProductEntity } from "../../entity_types/product";

export const p_sehz4fjtp7: FaireProductEntity = {
  token: "p_sehz4fjtp7",
  type: "product",
  name: "tulips place cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/78d3661521e79da7e6b4bcde1d7ce8c264c6343c143846ad52383ff6d1cbe177.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15524a29a6eccfa3330ffa16e228db836202723082892275e86cd58ab6214760.jpeg",
    "https://cdn.faire.com/fastly/9917f72a5693faadb2923dc38bb119acdcfb44450d773a360533a898a01894eb.jpeg",
    "https://cdn.faire.com/fastly/e0ec1cb2c9e7c37a37eb335b5a74f7501aae2cc40f88d0f8ead09cc869b373d1.jpeg",
  ],
  priceDollars: 5,
  description:
    'Set a cheerful table for your parties, luncheons, dinners, and showers with charming place cards for each guest. \n\nDetails:\n\n- set of eight place cards\n- blank space for name to be written\n- 2" x 3.5" when folded\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:10.739Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
